import React, { useState, useEffect } from 'react';
import { COLORS, FONT } from '../theme';
import { useAuth } from '../context/AuthContext';

export const ITENS_APP = [
  {
    chave: 'dashboard', titulo: 'Início', icone: 'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M9 22V12h6v10'
  },
  {
    chave: 'cadastros', titulo: 'Cadastros', icone: 'M9 12h6 M9 16h6 M13 3H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8z M13 3l5 5h-5z',
    grupo: [
      { chave: 'fornecedores', titulo: 'Fornecedor', perfis: ['admin', 'gestor', 'comprador'] },
      { chave: 'clientes', titulo: 'Cliente' },
      { chave: 'produtos', titulo: 'Produto' },
      { chave: 'transportadoras', titulo: 'Transportadora' }
    ]
  },
  {
    chave: 'compras', titulo: 'Compras', icone: 'M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z M3 6h18 M16 10a4 4 0 0 1-8 0',
    perfis: ['admin', 'gestor', 'comprador'],
    grupo: [
      { chave: 'ordens-compra', titulo: 'Ordens de Compra' },
      { chave: 'notas-entrada', titulo: 'Notas de Entrada' },
      { chave: 'recomendacao-compra', titulo: 'Recomendação de Compra' }
    ]
  },
  {
    chave: 'vendas', titulo: 'Vendas', icone: 'M3 3h2l.4 2M7 13h10l4-8H5.4 M7 13 5.4 5 M7 13l-2.3 2.3A1 1 0 0 0 5.4 17H17 M9 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2z M20 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2z',
    perfis: ['admin', 'gestor', 'vendedor'],
    grupo: [
      { chave: 'propostas', titulo: 'Propostas' },
      { chave: 'pedidos', titulo: 'Pedidos' },
      { chave: 'negociacao', titulo: 'Negociação', perfis: ['admin', 'gestor'] }
    ]
  },
  {
    chave: 'estoque-menu', titulo: 'Estoque', icone: 'M3 7l9-4 9 4-9 4-9-4Z M3 7v10l9 4 9-4V7 M12 11v10',
    grupo: [
      { chave: 'estoque', titulo: 'Estoque' },
      { chave: 'separacao', titulo: 'Separação', perfis: ['admin', 'gestor', 'estoquista'] }
    ]
  },
  {
    chave: 'rh', titulo: 'RH', icone: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M22 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75',
    perfis: ['admin', 'gestor'],
    grupo: [
      { chave: 'funcionarios', titulo: 'Funcionários' },
      { chave: 'ponto', titulo: 'Ponto' },
      { chave: 'vale-transporte', titulo: 'Vale Transporte' },
      { chave: 'vale-alimentacao', titulo: 'Vale Alimentação' },
      { chave: 'folha-pagamento', titulo: 'Folha de Pagamento' },
      { chave: 'comissoes', titulo: 'Comissões' },
      { chave: 'metas', titulo: 'Metas' },
      { chave: 'ferias', titulo: 'Férias' },
      { chave: 'decimo-terceiro', titulo: '13º Salário' },
      { chave: 'rescisao', titulo: 'Rescisão' }
    ]
  },
  {
    chave: 'financeiro', titulo: 'Financeiro', icone: 'M12 1v22 M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6',
    perfis: ['admin', 'gestor'],
    grupo: [
      { chave: 'contas-pagar', titulo: 'Contas a Pagar' },
      { chave: 'contas-pagar-calendario', titulo: 'Calendário a Pagar' },
      { chave: 'contas-receber', titulo: 'Contas a Receber' },
      { chave: 'contas-receber-calendario', titulo: 'Calendário a Receber' },
      { chave: 'ressarcimento-st', titulo: 'Ressarcimento ICMS-ST' }
    ]
  }
];

// Lista achatada de todas as telas do app (fora as do super-admin Coren), agrupadas pelo
// mesmo título do menu — usada pela tela de Permissões pra montar os checkboxes.
export function listarTelasDisponiveis() {
  const telas = [];
  ITENS_APP.forEach(item => {
    (item.grupo || [item]).forEach(sub => {
      telas.push({ chave: sub.chave, titulo: sub.titulo, grupoTitulo: item.titulo, perfis: sub.perfis || item.perfis || null });
    });
  });
  telas.push({ chave: 'empresas', titulo: 'Empresas', grupoTitulo: 'Configurações', perfis: ['admin', 'gestor'] });
  telas.push({ chave: 'depositos', titulo: 'Depósitos', grupoTitulo: 'Configurações', perfis: null });
  telas.push({ chave: 'regioes-entrega', titulo: 'Regiões de Entrega', grupoTitulo: 'Configurações', perfis: ['admin', 'gestor'] });
  telas.push({ chave: 'dados-bancarios', titulo: 'Dados Bancários e Pix', grupoTitulo: 'Configurações', perfis: ['admin', 'gestor'] });
  telas.push({ chave: 'auditoria', titulo: 'Log de Auditoria', grupoTitulo: 'Configurações', perfis: ['admin', 'gestor'] });
  return telas;
}

// Telas que esse perfil vê por padrão, antes de qualquer customização feita na tela de Permissões.
export function telasPadraoDoPerfil(perfil) {
  return listarTelasDisponiveis().filter(t => !t.perfis || t.perfis.includes(perfil)).map(t => t.chave);
}

export const ITENS_ADMIN = [
  { chave: 'clientes', titulo: 'Clientes', icone: 'M3 21V8l9-5 9 5v13 M9 21v-6h6v6' },
  { chave: 'usuarios', titulo: 'Usuários', icone: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M22 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75' },
  { chave: 'backups', titulo: 'Backups', icone: 'M4 4h16v6H4z M4 14h16v6H4z M8 7h.01 M8 17h.01' }
];

function Icone({ d, size = 17 }) {
  const paths = Array.isArray(d) ? d : d.split(' M').map((p, i) => (i === 0 ? p : 'M' + p));
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
      {paths.map((p, i) => <path key={i} d={p} />)}
    </svg>
  );
}

export default function Sidebar({ paginaAtiva, onNavegar, itens = ITENS_APP }) {
  const { empresaAtual } = useAuth();
  const [aberta, setAberta] = useState(true);
  const largura = aberta ? 240 : 64;

  const grupoAtivo = itens.find(item => item.grupo && item.grupo.some(sub => sub.chave === paginaAtiva));
  const [grupoAberto, setGrupoAberto] = useState(() => grupoAtivo ? grupoAtivo.chave : null);

  // Se a página ativa mudar por fora (ex: clicando na engrenagem da barra superior),
  // expande automaticamente o grupo do menu que contém essa página.
  useEffect(() => {
    if (grupoAtivo) setGrupoAberto(grupoAtivo.chave);
  }, [paginaAtiva]); // eslint-disable-line

  return (
    <aside style={{
      width: largura, flexShrink: 0, position: 'sticky', top: 0, height: '100vh',
      background: COLORS.sidebar, backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
      borderRight: `1px solid ${COLORS.border}`, boxShadow: '2px 0 16px rgba(30,41,59,0.06)',
      display: 'flex', flexDirection: 'column',
      transition: 'width .22s cubic-bezier(.4,0,.2,1)', fontFamily: FONT
    }}>
      <div style={{
        padding: aberta ? '14px 12px' : '14px 6px', borderBottom: `1px solid ${COLORS.border}`,
        display: 'flex', justifyContent: 'center'
      }}>
        <img src={empresaAtual?.logo_url || '/logo-coren-pt.png'} alt={empresaAtual?.nome || 'Coren'} style={{ height: aberta ? 64 : 44, maxWidth: '100%', objectFit: 'contain' }} />
      </div>

      <nav style={{ flex: 1, padding: '14px 8px', display: 'flex', flexDirection: 'column', gap: 2, overflowY: 'auto' }}>
        {itens.map(item => {
          if (item.grupo) {
            const grupoExpandido = grupoAberto === item.chave;
            const algumSubAtivo = item.grupo.some(sub => sub.chave === paginaAtiva);
            return (
              <div key={item.chave}>
                <button
                  onClick={() => {
                    if (!aberta) setAberta(true);
                    setGrupoAberto(g => g === item.chave ? null : item.chave);
                  }}
                  title={item.titulo}
                  style={{
                    width: '100%', display: 'flex', alignItems: 'center', gap: 10,
                    padding: aberta ? '9px 12px' : '9px 0', justifyContent: aberta ? 'space-between' : 'center',
                    borderRadius: 10, border: 'none',
                    background: algumSubAtivo ? 'rgba(29,107,240,0.12)' : 'transparent',
                    color: algumSubAtivo ? COLORS.primary : COLORS.textMid,
                    fontWeight: algumSubAtivo ? 700 : 400, fontSize: 13, fontFamily: FONT,
                    textAlign: 'left', cursor: 'pointer'
                  }}
                >
                  <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <Icone d={item.icone} />
                    {aberta && item.titulo}
                  </span>
                  {aberta && (
                    <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}
                      style={{ transform: grupoExpandido ? 'rotate(180deg)' : 'none', transition: 'transform .18s', flexShrink: 0 }}>
                      <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </button>

                {aberta && grupoExpandido && (() => {
                  const corDaChave = (chave) => chave.includes('pagar') ? '#fca5a5' : chave.includes('receber') ? '#86efac' : COLORS.border;
                  const blocos = [];
                  item.grupo.forEach(sub => {
                    const cor = corDaChave(sub.chave);
                    const ultimo = blocos[blocos.length - 1];
                    if (ultimo && ultimo.cor === cor) ultimo.itens.push(sub);
                    else blocos.push({ cor, itens: [sub] });
                  });
                  return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 2, marginLeft: 14 }}>
                      {blocos.map((bloco, i) => (
                        <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: 1, paddingLeft: 12, borderLeft: `2px solid ${bloco.cor}` }}>
                          {bloco.itens.map(sub => {
                            const ativa = sub.chave === paginaAtiva;
                            return (
                              <button
                                key={sub.chave}
                                onClick={() => onNavegar(sub.chave)}
                                style={{
                                  padding: '8px 10px', borderRadius: 8, border: 'none', textAlign: 'left', cursor: 'pointer',
                                  background: ativa ? 'rgba(29,107,240,0.12)' : 'transparent',
                                  color: ativa ? COLORS.primary : COLORS.textMid,
                                  fontWeight: ativa ? 700 : 400, fontSize: 13, fontFamily: FONT
                                }}
                              >
                                {sub.titulo}
                              </button>
                            );
                          })}
                        </div>
                      ))}
                    </div>
                  );
                })()}
              </div>
            );
          }

          const ativa = item.chave === paginaAtiva;
          return (
            <button
              key={item.chave}
              onClick={() => onNavegar(item.chave)}
              title={item.titulo}
              style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: aberta ? '9px 12px' : '9px 0', justifyContent: aberta ? 'flex-start' : 'center',
                borderRadius: 10, border: 'none',
                background: ativa ? 'rgba(29,107,240,0.12)' : 'transparent',
                color: ativa ? COLORS.primary : COLORS.textMid,
                fontWeight: ativa ? 700 : 400, fontSize: 13, fontFamily: FONT,
                textAlign: 'left', cursor: 'pointer'
              }}
            >
              <Icone d={item.icone} />
              {aberta && item.titulo}
            </button>
          );
        })}
      </nav>

      <div style={{ padding: 10 }}>
        <button
          onClick={() => setAberta(a => !a)}
          style={{
            width: '100%', background: 'rgba(29,107,240,0.07)', border: `1px solid ${COLORS.border}`,
            borderRadius: 9, padding: 9, cursor: 'pointer', color: COLORS.textMid,
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}
        >
          <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}
            style={{ transform: aberta ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }}>
            <path d="M9 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </aside>
  );
}
